import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = (companyId) => ['Receivable/account_types', companyId];

const getReceivableAccountTypes = async (companyId) => {
  return request.get(
    '/Receivable/account_types',
    { companyId },
    'При получении типов ЛС, по которым есть баланс в ЖФ произошла ошибка'
  );
};

const useReceivableAccountTypes = (companyId, options) =>
  useQuery(key(companyId), () => getReceivableAccountTypes(companyId), options);

export default useReceivableAccountTypes;
